// @flow
export const DEPARTURE = 'departure';
export const COMPLETION = 'completion';
export const DIRECT_MESSAGE = 'direct';



// WEBPACK FOOTER //
// ./src/scripts/components/NotificationElement/types.js